<template>
  <div class="section-navigation">
    <ul class="filter-list">
      <li v-for="section in allSections" :class="{ active: checkActiveSection(section) }">
        <a :href="'#/' + section" :name="section" :title="section" @click.prevent="setActiveSection(section)">
          <span tabindex="-1">
            {{ sectionTitle(section) }}
          </span>
        </a>
      </li>
    </ul>
    <div class="select-arrow-wrapper">
      <div class="select-down-arrow">
        <svg width="20px" height="12px" viewBox="0 0 20 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="red-down-arrow" transform="translate(-1198.000000, -24.000000)">
            <g id="News">
              <polygon id="Page-1" points="1216.47226 24 1207.99964 32.4729827 1199.52738 24 1198 25.5277378 1207.99964 35.5273775 1218 25.5277378"></polygon>
            </g>
          </g>
        </svg>
      </div>
      <select name="mountain_section_select" aria-label="Tabbed Navigation for Mountain Sections" title="Tabbed Navigation for Mountain Sections" @change="setActiveSection($event.target.value)">
        <option v-for="section in allSections" :selected="checkActiveSection(section)" :value="section">
          {{ sectionTitle(section) }}
        </option>
      </select>
    </div>

    <p class="disclaimer" v-if="showLegalDisclaimer" v-html="'* ' + legalDisclaimer"></p>
    <p class="additional-text" v-if="showAdditionalTextOnUphill" v-html="'* ' + additionalText"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SectionNavigation',
  data() {
    return {
      activeSection: 'trails',
    };
  },
  components: { },
  created() {
    const { path } = this.$route;
    if (path !== '/') {
      this.setActiveSection(path.replace('/', ''));
      // scroll to anchor here?
      setTimeout(() => {
        const section = document.querySelectorAll('.section-navigation')[0];
        window.scrollBy(section.offsetTop, section.offsetTop);
      }, 1000);
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/' || to.path == '/trails') {
        this.setActiveSection('trails');
      } else {
        this.setActiveSection(to.path.replace('/', ''));
      }
    },
  },
  computed: {
    ...mapState(['allSections', 'attractionsText', 'legalDisclaimer', 'additionalText']),
    legalDisclaimerPresent() {
      return typeof (this.legalDisclaimer) !== 'undefined' && this.legalDisclaimer !== '--';
    },
    additionalTextPresent() {
      return typeof (this.additionalText) !== 'undefined' && this.additionalText !== '--';
    },
    showLegalDisclaimer() {
      if (this.legalDisclaimerPresent !== true) { return false; }

      if (this.activeSection === 'uphill') { return false; }
      return this.activeSection === 'trails' || this.activeSection === 'lifts';
    },
    showAdditionalTextOnUphill() {
      if (this.additionalTextPresent !== true) { return false; }

      if (this.activeSection !== 'uphill') { return false; }
      return this.activeSection === 'uphill';
    },
  },
  methods: {
    sectionTitle(sectionName) {
      if (sectionName == 'attractions') { return this.attractionsText; }

      return this.$t(sectionName);
    },
    checkActiveSection(sectionName) {
      const routeName = this.$route.path.replace('/', '');
      return (this.activeSection == sectionName || routeName.indexOf(sectionName) > -1);
    },
    setActiveSection(section) {
      this.activeSection = section;
      this.$router.push({ path: `/${section}` });
      this.$store.commit('SET_ACTIVE_MOUNTAIN_SECTION', section);
    },
  },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .section-navigation {
      position: relative;

      ul.filter-list {
        display: inline-block;
        margin-bottom: 10px;
        @media screen and (min-width: $tablet) {
          display: block;
          min-height: auto;
        }
        li {
          display: none;
          letter-spacing: 0.85px;
          margin-right: 10px;
          text-transform: uppercase;
          vertical-align: baseline;
          &.active {
            display: inline-block;
            a {
              font-size: 30px;
              @media (min-width: $tablet) {
                font-size: 40px;
              }
            }
          }
          a {
            color: $medium-gray;
            font-family: $headline-font-regular;
            font-size: 32px;
            font-weight: 500;
            line-height: 1;
            letter-spacing: 0.8px;
          }
          @media screen and (min-width: $tablet) {
            display: inline-block;
            margin-right: 20px;
          }
        }
      }
      .select-arrow-wrapper {
        display: inline-block;
        width: auto;
        .select-down-arrow {
          float: left;
          margin-top: 0;
          @media (min-width: $tablet) {
            display: none;
          }
          svg {
            width: 20px;
          }
        }
        select {
          display: block;
          height: 70%;
          left: 0;
          opacity: 0;
          position: absolute;
          top: 0%;
          width: 70%;
          z-index: 10;
          @media screen and (min-width: $tablet) {
            display: none;
          }
        }
      }
      p.disclaimer, p.additional-text {
        color: $medium-gray;
        font-family: $base-font-regular;
        font-size: 12px;
        line-height: 1.2;
        margin-bottom: 40px;
        @media screen and (min-width: $tablet) {
          font-size: 18px;
        }
      }
    }
  }
</style>

<i18n locale="fr-ca">
{
  "MAPS": "CARTES",
  "TRAILS": "PISTES",
  "LIFTS": "REMONTÉES",
  "UPHILL": "ASCENSION",
  "maps": "CARTES",
  "trails": "PISTES",
  "lifts": "REMONTÉES",
  "uphill": "ASCENSION"
}
</i18n>
